import {
  AlertTriangle,
  CloudOff,
  Inbox,
  LoaderCircle,
  RefreshCw,
  ShieldX,
} from "lucide-react";
import type { ReactNode } from "react";

type StateKind = "loading" | "empty" | "offline" | "error" | "permission";

const icons = {
  loading: LoaderCircle,
  empty: Inbox,
  offline: CloudOff,
  error: AlertTriangle,
  permission: ShieldX,
};

export function StatePanel({
  kind,
  title,
  detail,
  action,
}: {
  readonly kind: StateKind;
  readonly title: string;
  readonly detail: string;
  readonly action?: ReactNode;
}) {
  const Icon = icons[kind];
  return (
    <section
      className={`state-panel state-${kind}`}
      role="status"
      aria-live="polite"
    >
      <Icon
        aria-hidden="true"
        className={kind === "loading" ? "spin" : undefined}
      />
      <h2>{title}</h2>
      <p>{detail}</p>
      {action}
    </section>
  );
}

export function RetryButton({ onClick }: { readonly onClick: () => void }) {
  return (
    <button className="button secondary" type="button" onClick={onClick}>
      <RefreshCw aria-hidden="true" />
      Try again
    </button>
  );
}
